import {useEffect} from "react";
import {authClient} from "./App.jsx";

const Logoff = () => {
    useEffect(() => {
        const doLogoff = async () => {
            await authClient.signOut();
            window.close();
            }
        doLogoff();

        }, []);
    }

export default Logoff;